module.exports = __webpack_public_path__ + "058b57020f7ffd9f80382d87ec414bcb.png";